<template>
  <div class="add-banner">
    <div class="form-content">
      <el-form label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="语言" required>
              <el-select v-model="currentData.language_code" placeholder="请选择语言" style="width: 100%;">
                <el-option v-for="item in languageList" :key="item.code" :label="item.name" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标题">
              <el-input v-model="currentData.title" placeholder="请输入 Banner 标题" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 封面图上传 -->
        <el-form-item label="封面图" required>
          <upload-image
            :images="currentData.cover"
            :path="'banner'"
            :num="1"
            @success="handleCoverSuccess"
            @remove="handleCoverRemove"
          />
          <div style="font-size: 12px; color: #909399; margin-top: 5px;">
            建议尺寸：1920 x 600 像素
          </div>
        </el-form-item>

        <!-- 内容 -->
        <el-form-item label="内容">
          <el-input
            v-model="currentData.content"
            type="textarea"
            :rows="3"
            placeholder="请输入内容（选填）"
            maxlength="255"
            show-word-limit
          />
        </el-form-item>

        <!-- 关联产品 -->
        <el-form-item label="关联产品">
          <el-select
            v-model="currentData.product_id"
            placeholder="请选择关联产品（可不选）"
            clearable
            filterable
            style="width: 100%;"
          >
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <!-- 关联解决方案 -->
        <el-form-item label="关联方案">
          <el-select
            v-model="currentData.solution_id"
            placeholder="请选择关联解决方案（可不选）"
            clearable
            filterable
            style="width: 100%;"
          >
            <el-option
              v-for="item in solutionList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <!-- 排序 -->
        <el-form-item label="排序">
          <el-input-number v-model="currentData.sort" :min="0" :max="9999" controls-position="right" />
          <span style="margin-left: 10px; font-size: 12px; color: #909399;">数值越小越靠前</span>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表单操作 -->
    <div class="form-actions">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </div>
</template>

<script>
import { getLanguage } from '@/api/public'
import { getProducts, getSolutions } from '@/api/website'
import { addBanner, updateBanner } from '@/api/website'
import UploadImage from '@/components/tool/lib/upload/index.vue'

export default {
  name: 'AddBanner',
  components: {
    UploadImage
  },
  props: {
    banner: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      languageList: [],
      productList: [],
      solutionList: [],
      currentData: {
        language_code: 'zh',
        title: '',
        cover: '',
        content: '',
        product_id: 0,
        solution_id: 0,
        sort: 0
      }
    }
  },
  watch: {
    banner: {
      handler(newBanner) {
        if (newBanner) {
          this.currentData = {
            id: newBanner.id,
            language_code: newBanner.language_code || 'zh',
            title: newBanner.title || '',
            cover: newBanner.cover || '',
            content: newBanner.content || '',
            product_id: newBanner.product_id || 0,
            solution_id: newBanner.solution_id || 0,
            sort: newBanner.sort || 0
          }
        } else {
          this.resetForm()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getLanguageList()
    this.getProductList()
    this.getSolutionList()
  },
  methods: {
    async getLanguageList() {
      try {
        var res = await getLanguage()
        this.languageList = res.data || []
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    async getProductList() {
      try {
        var res = await getProducts({ page_count: 999 })
        if (res.code === 200) {
          this.productList = res.data.data || []
        }
      } catch (error) {
        console.error('获取产品列表失败:', error)
      }
    },
    async getSolutionList() {
      try {
        var res = await getSolutions({ page_count: 999 })
        if (res.code === 200) {
          this.solutionList = res.data.data || []
        }
      } catch (error) {
        console.error('获取解决方案列表失败:', error)
      }
    },
    resetForm() {
      this.currentData = {
        language_code: 'zh',
        title: '',
        cover: '',
        content: '',
        product_id: 0,
        solution_id: 0,
        sort: 0
      }
    },
    handleCoverSuccess(images) {
      if (images && images.length > 0) {
        this.currentData.cover = images[0]
      }
    },
    handleCoverRemove() {
      this.currentData.cover = ''
    },
    handleSubmit() {
      if (!this.currentData.language_code) {
        this.$message.error('请选择语言')
        return
      }
      if (!this.currentData.cover) {
        this.$message.error('请上传封面图')
        return
      }

      var submitData = {
        language_code: this.currentData.language_code,
        title: this.currentData.title,
        cover: this.currentData.cover,
        content: this.currentData.content || '',
        product_id: this.currentData.product_id || 0,
        solution_id: this.currentData.solution_id || 0,
        sort: this.currentData.sort || 0
      }
      var isEdit = !!this.currentData.id

      var apiCall = isEdit
        ? updateBanner(this.currentData.id, submitData)
        : addBanner(submitData)

      apiCall.then(function(res) {
        if (res.code === 200) {
          this.$message.success(isEdit ? '编辑成功' : '新增成功')
          this.$emit('save', true)
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      }.bind(this)).catch(function() {
        this.$message.error('保存失败')
      }.bind(this))
    }
  }
}
</script>

<style scoped lang="scss">
.add-banner {
  box-sizing: border-box;
  padding: 0 20px;
}

.form-content {
  box-sizing: border-box;
  margin-bottom: 30px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f5;
}

/* 响应式 */
@media (max-width: 768px) {
  .add-banner {
    padding: 10px 0;
  }

  .form-content {
    margin-bottom: 20px;
  }

  .form-actions {
    flex-direction: column;
  }

  .form-actions .el-button {
    width: 100%;
  }
}
</style>
